export default Object.freeze({
  SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
  SET_ACTIVE_NAVIGATOR: "SET_ACTIVE_NAVIGATOR",
  SET_ACTIVE_NAVIGATOR_INDEX: "SET_ACTIVE_NAVIGATOR_INDEX",
  SET_CHILD_HEADER: "SET_CHILD_HEADER",
  SET_ROOT_NAVIGATOR: "SET_ROOT_NAVIGATOR",
  SET_ROOT_MODAL_STATUS: "SET_ROOT_MODAL_STATUS"
});
